import { Route, Routes } from "react-router-dom";

import { Routes as AdminRoutes } from "ui/modules/navigation";

import { CronJobsSearchPage } from "../pages/CronJobsSearchPage";
import { CronJobDetailPage } from "../pages/CronJobDetailPage";
import { CronJobExecutionPage } from "../pages/CronJobExecutionPage";

import { CronJobRouterCmp } from "./types";

/**
 * Obrade: popis vrsta obrada → vrsta obrade s njezinim obradama → log jedne obrade.
 */
const CronJobRouter: CronJobRouterCmp = () => (
  <Routes>
    <Route path={CronJobsSearchPage.route} element={<CronJobsSearchPage />} />
    <Route path={CronJobDetailPage.route} element={<CronJobDetailPage />} />
    <Route path={CronJobExecutionPage.route} element={<CronJobExecutionPage />} />
  </Routes>
);

CronJobRouter.route = AdminRoutes.ModuleRouter;

export default CronJobRouter;
